import { FormikProps, FormikValues } from 'formik';
import { REGISTRATION_TYPES } from '../ducks/constants';
import { breakDate } from '../../forms/utils';
import trimValues from '../../../utils/trim-values';
import { pushRegistrationGAEvent } from '@comeon/analytics';

const getCachedRegistrationDetails = () => {
	const cachedFormDetails = window.localStorage?.getItem('registration-details-form') || '{}';

	return JSON.parse(cachedFormDetails) as FormikProps<FormikValues> | Record<string, never>;
};

const hasCachedRegistration = () => {
	const cachedFormDetails = getCachedRegistrationDetails();
	return cachedFormDetails?.values && Object.keys(cachedFormDetails?.values).length > 0;
};
const getCachedRegValues = () => {
	const cachedFormDetails = getCachedRegistrationDetails();
	return cachedFormDetails?.values || {};
};

const isWEBOTPSupported = () => {
	return 'OTPCredential' in window && typeof AbortController !== 'undefined';
};

// Window check is necessary in case to prevent errors in case we have (SSR)
const isOnboardingFlowBEnabled = typeof window !== 'undefined' && localStorage.getItem('enableOnboardingFlowB');

const parseDate = (date: string, dateFormat: string) => {
	if (!date) return '';

	const parsedDate = dateFormat
		.replace('DD', date.substring(8, 10))
		.replace('MM', date.substring(5, 7))
		.replace('YYYY', date.substring(0, 4));

	return parsedDate;
};

type ManagePayloadArgs = {
	values: Record<string, string | boolean | null>;
	countryCode: string;
	inputProvider?: string;
	registrationType?: keyof typeof REGISTRATION_TYPES;
};

const managePayload = ({
	values,
	countryCode,
	inputProvider = 'MANUAL',
	registrationType = REGISTRATION_TYPES.FULL_REGISTRATION
}: ManagePayloadArgs) => {
	let payload = { ...values };

	payload.year = '';
	payload.month = '';
	payload.day = '';
	payload.inputTransactionId = null;
	payload.inputProvider = inputProvider;
	payload.gender = payload.gender ?? 'FEMALE';
	payload.registrationType = registrationType;

	if (payload.birthday) {
		const parsedBirthday = breakDate(payload.birthday as string);
		if (parsedBirthday) {
			payload.year = parsedBirthday.year;
			payload.month = parsedBirthday.month;
			payload.day = parsedBirthday.day;
		}
	}

	payload = trimValues(payload);

	if (payload.acceptMarketingOffers !== false) {
		payload.acceptMarketingOffers = true;
	}

	payload.country = payload.country ?? countryCode;

	return payload;
};

const handleRegistrationPixelTrack = (action: string, screenName: string) => {
	pushRegistrationGAEvent({
		type: 'UsernamePw',
		action,
		step: screenName,
		regScreen: screenName
	});
};

export {
	getCachedRegistrationDetails,
	hasCachedRegistration,
	getCachedRegValues,
	isWEBOTPSupported,
	isOnboardingFlowBEnabled,
	parseDate,
	managePayload,
	handleRegistrationPixelTrack
};
